import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          {/* About Section */}
          <div className="footer-section">
            <div className="footer-logo">
              <img src="https://proctur.com/assets/img/logo.svg" alt="Proctur" />
            </div>
            <p className="footer-description">
              Proctur is a comprehensive school management software that helps educational institutions
              streamline their operations. Our form templates are part of the Proctur ecosystem,
              designed to simplify admissions, registrations, feedback collection, and all educational processes.
            </p>
            <div className="footer-social">
              <a href="https://www.facebook.com/proctur" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="https://twitter.com/proctur" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://www.linkedin.com/company/proctur" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <i className="fab fa-linkedin"></i>
              </a>
              <a href="https://www.youtube.com/c/Proctur" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#templates">Browse Templates</a></li>
              <li><a href="#features">Features</a></li>
              <li><a href="#categories">Categories</a></li>
              <li><a href="https://proctur.com" target="_blank" rel="noopener noreferrer">About Proctur</a></li>
              <li><a href="https://proctur.com/website/contact-us" target="_blank" rel="noopener noreferrer">Contact Us</a></li>
            </ul>
          </div>

          {/* Categories */}
          <div className="footer-section">
            <h4 className="footer-heading">Categories</h4>
            <ul className="footer-links">
              <li><Link to="/form/iifd-surat">Design Institute</Link></li>
              <li><Link to="/form/demo-institute">Modern Institute</Link></li>
              <li><Link to="/form/coaching-demo">Coaching Center</Link></li>
              <li><Link to="/form/college-demo">College</Link></li>
              <li><Link to="/form/university-demo">University</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-section">
            <h4 className="footer-heading">Contact Us</h4>
            <ul className="footer-contact">
              <li>
                <i className="fa fa-envelope"></i>
                <a href="mailto:support@proctur.com">support@proctur.com</a>
              </li>
              <li>
                <i className="fa fa-phone"></i>
                <a href="tel:+919099229933">+91 90992 29933</a>
              </li>
              <li>
                <i className="fa fa-map-marker-alt"></i>
                <span>Proctur Technologies Pvt Ltd, Surat, Gujarat, India</span>
              </li>
              <li>
                <i className="fa fa-globe"></i>
                <a href="https://proctur.com" target="_blank" rel="noopener noreferrer">www.proctur.com</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2025 Proctur Technologies Pvt Ltd. All rights reserved.</p>
            <div className="footer-bottom-links">
              <a href="https://proctur.com/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
              <span>•</span>
              <a href="https://proctur.com/terms-and-conditions/" target="_blank" rel="noopener noreferrer">Terms of Service</a>
              <span>•</span>
              <a href="https://proctur.com/website/contact-us" target="_blank" rel="noopener noreferrer">Support</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
